import ValidateDefaults from 'validation/ValidateDefaults';

export default class ValidateRequired extends ValidateDefaults {
    constructor(obj) {
        super(obj);

        this.on = obj.on && Array.isArray(obj.on) ? obj.on : ['blur'];
    }

    validate(str) {
        if (!str) {
            return false;
        } else if (typeof str === 'number') {
            return str > 0; // workaround for edu verify form university id required
        }

        return str === true || str.trim().length > 0;
    }

    static defaultMessage(label) {
        return label + ' is required';
    }
}
